module.exports = __webpack_public_path__ + "assets/media/lunch.64ea24af.mp3";